import classNames from 'classnames'

import { ProductCTAConstants } from './constants'
import styles from './productCTA.module.scss'
import { DisplayTextType } from './types'

export const ProductDisplayText = ({ date, className, isQuickATCForMobile }: DisplayTextType) => {
  return (
    <div
      className={classNames(
        styles.displayTextWrapper,
        className,
        isQuickATCForMobile && styles.displayTextWrapper__quickATC,
      )}
    >
      {ProductCTAConstants.OUT_OF_STOCK}
      {date ? ` | ${ProductCTAConstants.BACK_IN_STOCK} ${date}` : ''}
    </div>
  )
}
